$(function() {
    var $selector = $(document),
        $forms = $selector.parents()
            .addBack()
            .filter("form")
            .add($selector.find("form"))
            .has("[data-val=true]");

    $selector.find("[data-val=true]").each(function () {
        var element = $(this), form = element.parents("form");
        if (!form) {  // Cannot do client-side validation without a form
            return;
        }

        var v = form.validate();
        element.on("input", function( e ) {
            if ( this.name in v.submitted || this.name in v.invalid ) {
                v.element(this);
            }
        });
    });
});